import _classCallCheck from "/home/gonzalo/wfdev/webfarming-app-client/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/gonzalo/wfdev/webfarming-app-client/node_modules/@babel/runtime/helpers/esm/createClass";
import ArrayList from '../../../../../java/util/ArrayList';
import OverlayOp from './OverlayOp';
var PointBuilder = /*#__PURE__*/function () {
  function PointBuilder() {
    _classCallCheck(this, PointBuilder);
    PointBuilder.constructor_.apply(this, arguments);
  }
  _createClass(PointBuilder, [{
    key: "filterCoveredNodeToPoint",
    value: function filterCoveredNodeToPoint(n) {
      var coord = n.getCoordinate();
      if (!this._op.isCoveredByLA(coord)) {
        var pt = this._geometryFactory.createPoint(coord);
        this._resultPointList.add(pt);
      }
    }
  }, {
    key: "extractNonCoveredResultNodes",
    value: function extractNonCoveredResultNodes(opCode) {
      for (var nodeit = this._op.getGraph().getNodes().iterator(); nodeit.hasNext();) {
        var n = nodeit.next();
        if (n.isInResult()) continue;
        if (n.isIncidentEdgeInResult()) continue;
        if (n.getEdges().getDegree() === 0 || opCode === OverlayOp.INTERSECTION) {
          var label = n.getLabel();
          if (OverlayOp.isResultOfOp(label, opCode)) this.filterCoveredNodeToPoint(n);
        }
      }
    }
  }, {
    key: "build",
    value: function build(opCode) {
      this.extractNonCoveredResultNodes(opCode);
      return this._resultPointList;
    }
  }], [{
    key: "constructor_",
    value: function constructor_() {
      this._op = null;
      this._geometryFactory = null;
      this._resultPointList = new ArrayList();
      var op = arguments[0],
        geometryFactory = arguments[1],
        ptLocator = arguments[2];
      this._op = op;
      this._geometryFactory = geometryFactory;
    }
  }]);
  return PointBuilder;
}();
export { PointBuilder as default };